import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, delay, mergeMap, retryWhen, take } from 'rxjs/operators';

export interface ErrorResponse {
  error: HttpErrorResponse;
  status: number;
  message: any;
  display: any;
}

const GENERIC_ERROR = 'There was an error. Please try again.';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retryWhen((errors) => {
          return errors.pipe(mergeMap(error => error.status === 429 ? of(error) : throwError(error)), delay(1000), take(2));
        }), catchError((error: HttpErrorResponse | ErrorResponse) => {
          const status = error instanceof HttpErrorResponse ? error.status : (error as ErrorResponse)?.status;
          let display = GENERIC_ERROR;

          if (status === 401) {
            display = 'Your session has expired. Please sign in again.';
          } else if (status === 403) {
            display = 'Unauthorized';
          } else if (status === 404) {
            display = 'Failed to load, Not Found';
          }

          if (error instanceof HttpErrorResponse && !(error.error instanceof Blob)) {
            const errorResult = { error, status, message: display, display };
            return throwError(errorResult);
          }

          if (!(error instanceof HttpErrorResponse)) {
            const errorResult = { ...(error as ErrorResponse), status, message: display, display };
            return throwError(errorResult);
          }

          return throwError(error);
        })
      );
  }

}
